import { createReducer, on } from '@ngrx/store';
import { storeFirstFilePartnerRegister } from '../../actions/file-patner-register.actions';

export interface IStateFirstFilePartnerRegister {
  file: File | null;
}

export const initialState: IStateFirstFilePartnerRegister = {
  file : null
}

export const firstFilePartnerRegisterReducer = createReducer(
  initialState,
  on(storeFirstFilePartnerRegister, (state, { file }) => ({...state, file}))
)
